import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import InfoTip from '../shared/InfoTip';
import { SERVER_INSTRUCTIONS_COPY as COPY } from './mcpUtils';

/**
 * Server-level `instructions`: guidance the calling model (Claude, Town…)
 * receives when it connects. Shared by the Settings tab and the create dialog.
 */
const McpInstructionsField = ({ value, onChange, disabled = false }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
    <Typography variant="body2" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.75 }}>
      {COPY.label}
      <InfoTip title={COPY.tooltip} />
    </Typography>
    <TextField
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      fullWidth
      size="small"
      multiline
      minRows={4}
      maxRows={14}
      placeholder={COPY.placeholder}
      helperText={COPY.helper}
    />
  </Box>
);

export default McpInstructionsField;
